module.exports = __webpack_public_path__ + "img/water.bbd683fe.svg";